import { useIntl } from "react-intl";
import React, { useState } from "react";
import ReactGA from "react-ga4";
import * as ReactDOM from "react-dom";

import {
  Banner,
  Content,
  Button,
  Icon,
  ReadyToStart,
  Layout,
  ItemList,
  Tips,
  Column,
} from "../../components";
import "../../components/Banner/Banner.scss";
import useAppContext from "../../context/Context";
import "./BusinessTransfer.scss";
import cl from "../../banks/quickTransfer_CL.json";
import mx from "../../banks/quickTransfer_MX.json";
import Modal from "../../components/Modal/Modal";
import logoBT from "../../assets/images/business-transfer/Business Transfer.svg";
import mockupHeader from "../../assets/images/business-transfer/Mockup-Header-BT_Chile.png";

import BT_Screen1 from "../../assets/images/business-transfer/Screen1.png";
import BT_Screen2 from "../../assets/images/business-transfer/Screen2.png";
import step3Animation from "../../assets/images/business-transfer/Step3-bt.svg";

import backgroundGrad from "../../assets/images/Grad_DD.jpg";

import illustration1 from "../../assets/images/business-transfer/Illustration01.svg";
import illustration1Animation from "../../assets/images/business-transfer/Path-animate-svg.svg";
import illustration2 from "../../assets/images/business-transfer/Illustration02.svg";
import svgAnimation1 from "../../assets/images/business-transfer/animationBT.svg";

export const BusinessTransfer = () => {
  ReactGA.send({ hitType: "pageview", page: "/business-transfer" });

  const { setStep, getImages, activeCountry } = useAppContext();
  const intl = useIntl();
  const [bankList, setBankList] = React.useState(null);

  React.useEffect(() => {
    setStep && setStep(1);
  }, []);

  const handleChangeBank = () => {
    activeCountry === "cl" ? setBankList(cl) : setBankList(mx);
  };

  React.useEffect(handleChangeBank, [activeCountry]);

  const [openModal, setOpenModal] = useState(false);

  const changeModal = () => {
    setOpenModal(!openModal);
  };

  const scrollAnimation1 = () => {
    const y = window.scrollY;
    const divAnimaton = document.getElementById("section3");
    if (y >= divAnimaton.offsetTop - 500) {
      document.getElementById("animation-add").classList.add("animation-add");
      document
        .getElementById("transfer-registered")
        .classList.add("transfer-registered");
      document
        .getElementById("transfer-authorized-loader")
        .classList.add("transfer-authorized-loader");

      document
        .getElementById("transfer-authorized")
        .classList.add("transfer-authorized");
      document
        .getElementById("transfer-authorized-check")
        .classList.add("transfer-authorized-check");
      document
        .getElementById("transfer-registered-opacity")
        .classList.add("transfer-registered-opacity");
    }
  };

  const scrollAnimationStep = () => {
    const y = window.scrollY;
    const divAnimaton = document.getElementById("bt-content-animtion-step3");
    if (y >= divAnimaton.offsetTop - 800) {
      document
        .getElementById("bt-step3-animation-ticket")
        .classList.add("bt-step3-animation-ticket");
      document
        .getElementById("bt-step3-animation-notification")
        .classList.add("bt-step3-animation-notification");
      document
        .getElementById("bt-step3-animation-check")
        .classList.add("bt-step3-animation-check");

      document
        .getElementById("bt-step3-animation-check-empty")
        .classList.add("bt-step3-animation-check-empty");
      document
        .getElementById("transfer-authorized-check")
        .classList.add("transfer-authorized-check");
      document
        .getElementById("transfer-registered-opacity")
        .classList.add("transfer-registered-opacity");
    }
  };

  window.addEventListener("scroll", scrollAnimation1);
  window.addEventListener("scroll", scrollAnimationStep);

  return (
    <Layout className="quick-transfer">
      {openModal === true &&
        ReactDOM.createPortal(
          <Modal
            changeModal={changeModal}
            content={
              <iframe
                title="Formulario de contacto"
                className="iframe"
                src={
                  activeCountry === "mx"
                    ? "https://share.hsforms.com/14Hl-W1oeQx-uUbcs4v0x5A5l986"
                    : "https://share.hsforms.com/1nESwD7ncTxK4ewZnR1u7yQ5l986"
                }
                frameborder="0"
              ></iframe>
            }
          ></Modal>,
          document.getElementById("portal")
        )}

      <Banner
        customClass="business-transfer"
        background={backgroundGrad}
        styles={{ width: "54%", height: "93.5%" }}
      >
        {
          <Content
            content={
              <div className="banner-top-icon">
                <div style={{ padding: 0 }}>
                  <img
                    src={logoBT}
                    alt="Business Transfer icon"
                    height={49}
                    width={49}
                  />
                </div>
                <p>
                  {intl.formatMessage({ id: "business-transfer.section1" })}
                </p>
              </div>
            }
            title={intl.formatMessage({
              id: "business-transfer.section1.title",
            })}
            subtitle={intl.formatMessage({
              id: "business-transfer.section1.subtitle",
            })}
            footer={
              <>
                <a href="https://dashboard.etpay.com/sign-up">
                  <Button
                    bgColor={"#646174"}
                    bgHoverColor="#140F33"
                    color="#fff"
                  >
                    <Icon name={"Icon_Pre"} className="fillable" fill="#fff" />
                    <span>
                      {intl.formatMessage({
                        id: "business-transfer.section1.textButton",
                      })}
                    </span>
                  </Button>
                </a>
              </>
            }
            customClass="grid-6 content-business-transfer"
          />
        }
        <div
          className="image-banner"
          style={{
            gridColumn: "7 / 13",
            marginTop: "4.7rem",
            width: "100%",
            //   backgroundImage: "url(../../public/Grad_DD.jpg)"
          }}
        >
          {<img src={mockupHeader} alt="" />}
        </div>
      </Banner>
      <Tips
        tip1={intl.formatMessage({ id: "business-transfer.section1.tip1" })}
        tip2={intl.formatMessage({ id: "business-transfer.section1.tip2" })}
        tip3={intl.formatMessage({ id: "business-transfer.section1.tip3" })}
        customClass="tips-business-transfer"
      ></Tips>
      <div>
        <section className="section-competition">
          <div className="section2-competition-content">
            <span style={{ color: "#646174" }}>
              {" "}
              {intl.formatMessage({ id: "business-transfer.section2.title1" })}
            </span>
            <h4 className="section2-title">
              {intl.formatMessage({ id: "business-transfer.section2.title2" })}
            </h4>
            <p className="section2-text">
              {intl.formatMessage({ id: "business-transfer.section2.text" })}
            </p>
          </div>
        </section>
        <section>
          <div className="container-list-section">
            <section className="section3" id="section3">
              <div className="section3-animation">
                <Icon src={illustration1} className="section3-illustration1" />
                {/* <img src={illustration1} alt="" /> */}
                <Icon src={illustration1Animation} styles={{ margin: "0" }} />
              </div>
              <div className="section3-content-text">
                <h3 className="section3-title">
                  {intl.formatMessage({
                    id: "business-transfer.section3.title",
                  })}
                </h3>
                <p className="section3-p">
                  {intl.formatMessage({
                    id: "business-transfer.section3.text",
                  })}
                </p>
              </div>
            </section>
            <div className="container-bank container-bank-margin-top">
              <div>
                <h3 className="section3-title">
                  {intl.formatMessage({
                    id: "business-transfer.section3.bank.title",
                  })}
                </h3>
                <p className="section3-p animation2">
                  {intl.formatMessage({
                    id: "business-transfer.section3.bank.text",
                  })}
                </p>
                <div className="section3-container-banks">
                  <div className="section3-container-banks-gap">
                    <div className="section3-container-bank">
                      <Icon name={"Secure_BT"}></Icon>
                      <p className="">
                        {intl.formatMessage({
                          id: "business-transfer.section3.bank.bank1",
                        })}
                      </p>
                    </div>
                    <div className="section3-container-bank">
                      <Icon name={"Secure_BT"}></Icon>
                      <p className="">
                        {intl.formatMessage({
                          id: "business-transfer.section3.bank.bank2",
                        })}
                      </p>
                      <div className="section3-soon">
                        {intl.formatMessage({
                          id: "business-transfer.section3.bank.soon",
                        })}
                      </div>
                    </div>

                    <div className="section3-container-bank">
                      <Icon name={"Secure_BT"}></Icon>
                      <p className="">
                        {intl.formatMessage({
                          id: "business-transfer.section3.bank.bank3",
                        })}
                      </p>
                      <div className="section3-soon">
                        {intl.formatMessage({
                          id: "business-transfer.section3.bank.soon",
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div
                  className="bt-content-animation1"
                  id="bt-content-animation1"
                >
                  <Icon src={svgAnimation1} />
                </div>
              </div>
            </div>
            <div className="container-list-atm">
              <div className="bt-content-illustration2">
                <Icon src={illustration2} />
              </div>
              <div className="container-list">
                <h3>
                  {intl.formatMessage({
                    id: "business-transfer.section4.title",
                  })}
                </h3>
                <p className="section3-subtitle-list">
                  {intl.formatMessage({
                    id: "business-transfer.section4.text",
                  })}
                </p>
                <div className="items-list-atm section4-items-list-atm">
                  <div className="container-check">
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "business-transfer.section4.list.title1",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.text1",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "business-transfer.section4.list.title2",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.text2",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "business-transfer.section4.list.title3",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.text3",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "business-transfer.section4.list.title4",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.text4",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "business-transfer.section4.list.title5",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.text5",
                        })}
                      </p>
                    </ItemList>
                  </div>

                  <div className="container-check container-check-margin">
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "business-transfer.section4.list.title6",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.text6",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "business-transfer.section4.list.title7",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.text7",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        <span className="bold">
                          {intl.formatMessage({
                            id: "business-transfer.section4.list.title8",
                          })}{" "}
                        </span>
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.text8",
                        })}
                      </p>
                    </ItemList>
                    <ItemList>
                      <Icon name={"Check_BT"}></Icon>
                      <p className="section4-text">
                        {intl.formatMessage({
                          id: "business-transfer.section4.list.title9",
                        })}{" "}
                      </p>
                    </ItemList>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container-compatarive section5-padding-bottom">
            <h1 className="title-comparative-section">
              {intl.formatMessage({ id: "business-transfer.section5.title" })}
            </h1>
            <p className="subtitle-comparative-section">
              {intl.formatMessage({
                id: "business-transfer.section5.subtitle",
              })}
            </p>
            <div className="tab-atm">
              <div className="section5-item-tab">
                <div className="content-item">
                  <span>
                    {intl.formatMessage({
                      id: "business-transfer.section5.step1.title",
                    })}
                  </span>
                  <p>
                    {intl.formatMessage({
                      id: "business-transfer.section5.step1.text",
                    })}
                  </p>
                </div>
                <div className="content-item-img">
                  <img src={BT_Screen1} alt="" />
                </div>
              </div>
              <div className="section5-item-tab">
                <div className="content-item">
                  <span>
                    {intl.formatMessage({
                      id: "business-transfer.section5.step2.title",
                    })}
                  </span>
                  <p>
                    {intl.formatMessage({
                      id: "business-transfer.section5.step2.text",
                    })}
                  </p>
                </div>
                <div className="content-item-img">
                  <img src={BT_Screen2} alt="" />
                </div>
              </div>
              <div className="section5-item-tab">
                <div className="content-item">
                  <span>
                    {intl.formatMessage({
                      id: "business-transfer.section5.step3.title",
                    })}
                  </span>
                  <p>
                    {intl.formatMessage({
                      id: "business-transfer.section5.step3.text",
                    })}
                  </p>
                </div>
                <div className="content-item-img">
                  <div
                    className="bt-content-animtion-step3"
                    id="bt-content-animtion-step3"
                  ></div>
                  <Icon src={step3Animation} />
                  {/* <img src={BT_Screen3} alt="" /> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="tarifas section7">
            <Column>
              <h4 className="top-title" style={{ color: "#426DD8" }}>
                {intl.formatMessage({
                  id: "business-transfer.section7.title1",
                })}
              </h4>
              <h2 className="title">
                {intl.formatMessage({
                  id: "business-transfer.section7.title2",
                })}
              </h2>
              <h3 className="sub-title">
                {intl.formatMessage({ id: "business-transfer.section7.text1" })}
              </h3>
            </Column>
            <Column customClass="content">
              {/* 1 */}
              <div className="title hide-xs">
                {intl.formatMessage({ id: "business-transfer.section7.text2" })}
              </div>
              <div className="text">
                <div className="title show-xs"></div>
                <div className="description">
                  {intl.formatMessage({
                    id: "business-transfer.section7.text3",
                  })}
                </div>
              </div>
              <div className="value valueContainer">
                <div className="bt-percent">
                  {intl.formatMessage({
                    id: "business-transfer.section7.text4",
                  })}
                </div>
                <div className="bt-percent-description">
                  {intl.formatMessage({
                    id: "business-transfer.section7.text5",
                  })}
                </div>
              </div>
            </Column>
            <Column customClass="content">
              <div className="bt-description-fee">
                {intl.formatMessage({
                  id: "business-transfer.section7.text6",
                })}
              </div>
            </Column>
          </div>
        </section>

        <ReadyToStart></ReadyToStart>
      </div>
    </Layout>
  );
};
